import React, { useEffect, useState } from "react";
import InputLayout, { FLoatLabelInputLayout } from "./InputLayout";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Password } from "primereact/password";
import { Calendar } from "primereact/calendar";
import { InputSwitch } from "primereact/inputswitch";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { numberOnly } from "../../utils/regex";
import { capitalizeCamelCase } from "../../utils/commonFunctions";

export const CustomInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  ...props
}) => {
  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputText
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        type={type}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
        className={`input w-full border-round-lg ${inputClass ? inputClass : ""
          } ${errorMessage ? "p-invalid" : ""} ${value || data?.[name]}`}
        placeholder={placeholder || `${label}`}
        disabled={disabled}
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};

export const CustomInputTextArea = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  ...props
}) => {
  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputTextarea
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        type={type}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
        className={`input w-full border-round-lg ${inputClass ? inputClass : ""
          } ${errorMessage ? "p-invalid" : ""} ${value || data?.[name]}`}
        placeholder={placeholder || `${label}`}
        disabled={disabled}
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};

export const CustomInputNumber = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  useGrouping = false,
  maxLength = 10,
  ...props
}) => {

  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputNumber
        id={name}
        name={name}
        value={value || data?.[name] || null}
        type={type}
        onChange={(e) => {
          onChange && onChange({ ...e, name: name, value: e.value })
        }
        }
        onBlur={(e) => {
          if (!value && e.target.value) {
            onChange && onChange({ name, value: e.target.value });
          }
        }}
        className={`input w-full border-round-lg ${inputClass ? inputClass : ""
          } ${errorMessage ? "p-invalid" : ""}`}
        placeholder={placeholder || `${name}`}
        disabled={disabled}
        useGrouping={useGrouping}
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};

export const CustomNumberInput2 = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  spanExtraClassName,
  maxLength,
  ...props
}) => {
  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputText
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        type={type}
        onChange={(e) => {
          if (onChange) {
            if (numberOnly(e.target.value)) {
              onChange({ ...e, name: e.target.name, value: e.target.value });
            } else if (!e.target.value) {
              onChange({ ...e, name: e.target.name, value: e.target.value });
            }
          }
        }}
        className={`input w-full border-round-lg ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        placeholder={placeholder || `${capitalizeCamelCase(name)}`}
        disabled={disabled}
        maxLength={maxLength}
        {...props}
      />
    </FLoatLabelInputLayout>

  );
};

export const CustomPassword = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 12,
  inputClass,
  disabled = false,
  feedback = false,
  placeholder = "",
  ...props
}) => {
  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <Password
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
        className={`w-full block ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        inputClassName="w-full border-round-lg "
        disabled={disabled}
        feedback={feedback}
        toggleMask
        placeholder={placeholder || `${name}`}
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};

export const CustomDropDown = ({
  label,
  name,
  onChange,
  options,
  data,
  value,
  errorMessage,
  extraClassName,
  dropDownClassName,
  required,
  formArrayName,
  index,
  col = 6,
  optionLabel = "name",
  placeholder = "",
  highlightOnSelect = true,
  hideFloatlabel = false,
  ...props
}) => {
  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      hideFloatlabel={hideFloatlabel}
    >
      <Dropdown
        id={name}
        name={name}
        options={options}
        value={value || data?.[name]}
        onChange={(e) =>
          onChange &&
          onChange({
            ...e,
            name: e.target.name,
            value: e.value,
            formArrayName,
            index,
          })
        }
        className={`w-full custom-dropdown primary-color ${errorMessage ? "p-invalid" : ""
          } ${dropDownClassName}`}
        optionLabel={optionLabel}
        placeholder={placeholder || `Select ${name}`}
        highlightOnSelect={highlightOnSelect}
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};

export const NewCustomDropDown = ({
  label,
  name,
  onChange,
  options,
  data,
  value,
  errorMessage,
  extraClassName,
  dropDownClassName,
  required,
  formArrayName,
  index,
  col = 6,
  optionLabel = "name",
  placeholder = "",
  highlightOnSelect = true,
  ...props
}) => {
  return (
    // <FLoatLabelInputLayout
    //   col={col}
    //   label={label}
    //   name={name}
    //   required={required}
    //   extraClassName={extraClassName}
    //   data={data}
    //   errorMessage={errorMessage}
    // >
    <Dropdown
      id={name}
      name={name}
      options={options}
      value={value || data?.[name]}
      onChange={(e) =>
        onChange &&
        onChange({
          ...e,
          name: e.target.name,
          value: e.value,
          formArrayName,
          index,
        })
      }
      className={`w-full custom-dropdown primary-color ${errorMessage ? "p-invalid" : ""
        } ${dropDownClassName}`}
      optionLabel={optionLabel}
      placeholder={placeholder || `Select ${name}`}
      highlightOnSelect={highlightOnSelect}
      {...props}
    />
    // </FLoatLabelInputLayout>
  );
};


export const CustomCalander = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  placeholder = "",
  ...props
}) => {
  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      labelClassName="calendar-label"
    >
      <Calendar
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        onChange={(e) => onChange && onChange({ ...e, name, value: e.value })}
        className={`w-full ${inputClass ? inputClass : ""}`}
        disabled={disabled}
        placeholder={placeholder || `Select ${name}`}
        showIcon
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};

export const CustomCheckbox = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col,
  formArrayName,
  checked,
  index,
  inputClass,
  template,
  ...props
}) => {
  return (
    <InputLayout
      col={col || 6}
      name=""
      extraClassName={extraClassName}
      errorMessage={data?.formErrors?.[name]}
    >
      <Checkbox
        id={name}
        name={name}
        inputId={label}
        checked={checked || value || data?.[name]}
        onChange={(e) =>
          onChange &&
          onChange({
            ...e,
            name: e.target.name,
            value: e.checked,
            formArrayName,
            index,
          })
        }
        className={`checkbox ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        {...props}
      />

      {label && (
        <label htmlFor={label} className="ml-2 text-sm">
          {label}
        </label>
      )}

      {template && <>{template}</>}
    </InputLayout>
  );
};

export const CustomSwitch = ({
  label,
  name,
  data,
  value,
  onChange,
  col = 6,
  ...props
}) => {
  return (
    <InputLayout col={col} name="">
      <div className="flex">
        <InputSwitch
          checked={value || data?.[name]}
          onChange={(e) => onChange && onChange({ ...e, name, value: e.value })}
          {...props}
        />
        <div htmlFor={label} className="ml-2 my-auto">
          {label ? label : label}
        </div>
      </div>
    </InputLayout>
  );
};

export const CustomMemoryInput = ({
  label,
  name,
  data,
  value,
  onChange,

  typeValue,
  typeName,
  onTypeChange,

  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <div className="p-inputgroup flex-1">
        <InputText
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          type={type}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input w-full ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
            }`}
          placeholder={placeholder || `${name}`}
          disabled={disabled}
          {...props}
        />
        <Dropdown
          id={typeName}
          name={typeName}
          value={typeValue || data?.[typeName]}
          onChange={(e) =>
            onTypeChange &&
            onTypeChange({ ...e, name: e.target.name, value: e.value })
          }
          className="custom-dropdown w-3"
          options={["Pi", "Ti", "Gi", "Mi"]}
        />
      </div>
    </InputLayout>
  );
};

//New
export const CustomSearch = ({ value = "", onChange }) => {
  const [search, setSearch] = useState(value);
  useEffect(() => {
    if (onChange) {
      onChange(search);
    } // eslint-disable-next-line
  }, [search]);

  return (
    <div className="search-box">
      <i className="pi pi-search" />
      <InputText
        className="w-full"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        type="text"
      />
    </div>
  );
};

export const CustomForm = ({ children, title }) => {
  return (
    <form className="grid m-0 p-0">
      {title ? <div className="col-12 title my-auto">{title}</div> : null}
      {children}
    </form>
  );
};

export const CustomField = ({ label, name, data, value }) => {
  return (
    <div className="input-layout col-12 grid">
      <label htmlFor={name} className="text-sm font-semibold col-3">
        <div>{label ? label : name}</div>
      </label>
      <div className="col-9  overflow-x-auto">
        {value || data?.[name] || "-"}
      </div>
    </div>
  );
};


export const CustomOtpNumber = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  placeholder = "",
  maxLength,
  ...props
}) => {
  const handleChange = (e) => {
    // Allow only digits (0-9)
    const regex = /^[0-9]*$/;
    if (regex.test(e.target.value) || e.target.value === "") {
      onChange && onChange({
        ...e,
        name: name,
        value: e.target.value // Keep as string to preserve leading zeros
      });
    }
  };

  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputText
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        onChange={handleChange}
        className={`input w-full border-round-lg ${inputClass ? inputClass : ""} ${
          errorMessage ? "p-invalid" : ""
        }`}
        placeholder={placeholder || `${label}`}
        disabled={disabled}
        maxLength={maxLength}
        inputMode="numeric" // Shows numeric keyboard on mobile
        pattern="[0-9]*"   // Helps with mobile keyboard
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};
